import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth, CrossSpaLink } from '../shared';
import { LogoImage, Section } from '../styles';

import logo from '../images/logo_bw.png';

const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const LogoLink = styled(CrossSpaLink)`
    text-decoration: none;
    color: inherit;
    display: flex;
    justify-content: center;
    width: 100%;
`;

const AdminNavContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 16px;
`;

const AdminLink = styled(CrossSpaLink)`
    background: #007bff;
    color: white;
    padding: 8px 16px;
    border-radius: 6px;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    transition: background-color 0.2s;

    &:hover {
        background: #0056b3;
    }
`;

export const Header = () => {
    const { isAuthenticated } = useAuth();

    return (
        <HeaderContainer>
            <Section>
                <LogoLink to="/">
                    <LogoImage src={logo} alt="logo" />
                </LogoLink>
            </Section>
            {isAuthenticated && (
                <AdminNavContainer>
                    <AdminLink to="/admin">
                        Admin Dashboard
                    </AdminLink>
                </AdminNavContainer>
            )}
        </HeaderContainer>
    );
}